import { render, staticRenderFns } from "./ConfirmActionButton.vue?vue&type=template&id=f7f74554&"
import script from "./ConfirmActionButton.vue?vue&type=script&lang=ts&"
export * from "./ConfirmActionButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports